<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else class="vx-row">
      <vx-card>
        <vs-table
          :max-items="paginationItems[1]"
          pagination
          :data="reportsList"
          :description="false"
          search
          @selected="handleSelected"
          :description-items="paginationItems"
          description-title="Registries"
          description-connector="of"
          description-body="Pages"
        >
          <template slot="header">
            <div class="list-heading">
              {{ $t("system.label.ManageReports") }}
            </div>
            <div class="mr-2 mb-1 order-1">
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="$router.push('/createReport').catch(() => {})"
                size="small"
                >{{ $t("system.label.CreateReport") }}</vs-button
              >
            </div>
          </template>
          <template slot="thead">
            <vs-th>{{ $t("system.label.ReportName") }}</vs-th>
            <vs-th>{{ $t("system.label.ReportType") }}</vs-th>
            <vs-th>{{ $t("system.label.ReportSubtype") }}</vs-th>
            <vs-th>{{ $t("system.label.ReportCategory") }}</vs-th>
            <vs-th>{{ $t("system.label.CoreReport") }}</vs-th>
            <vs-th>{{ $t("system.label.UserReport") }}</vs-th>
            <vs-th class="tHeadCenter">{{ $t("system.label.Action") }}</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :key="index"
              :data="reportsList"
              v-for="(reportsList, index) in data"
            >
              <vs-td :data="reportsList.reportName">{{
                reportsList.reportName
              }}</vs-td>
              <vs-td :data="reportsList.reportType">{{
                reportsList.reportType
              }}</vs-td>
              <vs-td :data="reportsList.reportSubType">{{
                reportsList.reportSubType
              }}</vs-td>
              <vs-td :data="reportsList.reportCategory">{{
                reportsList.reportCategory
              }}</vs-td>
              <vs-td :data="reportsList.coreReport">{{
                reportsList.coreReport
              }}</vs-td>
              <vs-td :data="reportsList.useReport">{{
                reportsList.useReport
              }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EditIcon"
                    :title="$t('system.label.Edit')"
                    svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                    @click.stop="editManageReports(reportsList.reportId)"
                    class="icon_row"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    :title="$t('system.label.Delete')"
                    class="icon_row"
                    svgClasses="w-5 h-5 stroke-current cursor text-danger"
                    @click.stop="
                      conditionId = reportsList.id;
                      deleteManageReportPopup = true;
                    "
                  />
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteManageReportPopup"
      :title="$t('system.label.Manage_Report')"
      @deletePressed="deleteManageReport(conditionId)"
      @cancelPressed="deleteManageReportPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deleteManageReportPopup: false,
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapGetters({
      reportsList: "manageReport/getReportListDataList",
    }),
  },
  methods: {
    handleSelected(reportsList) {
      this.$router.push({ path: `/viewReports/${reportsList.reportId}` });
    },
    async getReportsData() {
      this.loading = true;
      try {
        await this.$store.dispatch("manageReport/setReportsData");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async deleteManageReport(id) {
      try {
        await this.$store.dispatch("manageReport/deletereportsAction", id);
        this.deleteManageReportPopup = false;
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Manage Report Successfully Deleted!!",
          type: "success",
        });
        this.$router.push("/reportsList");
      } catch (e) {
        this.$swal({
          title: "Failed",
          icon: "warning",
          text: e.message.errors[0].defaultUserMessage.replace(
            "The parameter",
            ""
          ),
          type: "warning",
        });
      }
    },
    editManageReports(id) {
      this.$router.push(`/editManageReports/${id}`);
    },
  },
  mounted() {
    this.getReportsData();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
